import { Version } from '@hemro/version/version';
import { environment } from 'environments';


export const HEMRO_VERSION = new Version(
    environment.buildVersion + '-' + environment.buildNumber,
).full;
